import {FatGreenOutlineButton} from 'common';
import {Pane} from 'evergreen-ui';
import {Offer} from 'offer';
import React, {memo, useState} from 'react';
import {Referral} from 'referral';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import { ErrorDialog } from '../../common/component/ErrorDialog';
import {useEditOffer$} from '../hook/useEditOffer$';
import {OfferForm} from './OfferForm';
import { OfferFormHeader } from './OfferFormHeader';
import {SubmissionInfo} from './SubmissionInfo';

type EditOfferFormProps = {
    referral: Referral;
    existingOffer: Offer;
    successCallback: (updatedOffer: Partial<Offer>) => any;
    cancelCallback: () => any;
};
export const EditOfferForm = memo(({
                                       referral,
                                       existingOffer,
                                       successCallback,
                                       cancelCallback,
                                   }: EditOfferFormProps
) => {
    const {execute: editOperation, isRunning$: isSubmitting$, errorMessage$} = useEditOffer$(
        existingOffer.guid,
        successCallback
    );

    const [submitSignal$] = useState(() => new Subject<boolean>());

    const [shouldValidateSignal$] = useState(() => new Subject<boolean>());
    const [validationResults$] = useState(() => new BehaviorSubject<boolean>(false));


    return (
        <Pane className="max-h-full h-full box-border portal-provider-offer-form-container flex flex-col overflow-y-scroll">
            <OfferFormHeader caseNumber={referral.caseNumber} onClose={cancelCallback} />
            <SubmissionInfo offer={existingOffer}/>
            <OfferForm referral={referral}
                       existingOffer={existingOffer}

                       validatePlease$={shouldValidateSignal$ as Observable<boolean>}
                       validationResult$={validationResults$}

                       submitPlease$={submitSignal$}
                       isSubmitting$={isSubmitting$}
                       submitOperation={editOperation}
            />
            <Pane className='portal-provider-offer-form-actions portal-provider-bg flex justify-evenly'>
                <Pane width={200}>
                    <FatGreenOutlineButton text='Cancel' type="button" onClick={cancelCallback}/>
                </Pane>
                <Pane width={200}>
                    <FatGreenOutlineButton text='Update' type='button'
                                           onClick={() => submitSignal$.next(true)}/>
                </Pane>
            </Pane>

            <ErrorDialog message$={errorMessage$} />
        </Pane>
    );
});
